import { cn } from "@/lib/utils";

/**
 * "방금 생겼다"를 알리는 8px 빨간 점 + 옅은 빨간 테두리 — Figma 6107:321953.
 *
 * 라벨의 오른쪽 위 모서리에 살짝 걸치게 놓는다(윗첨자 자리). 위치를 잡으려면 감싸는
 * 쪽이 `relative` 여야 하고, 글자를 자르는 요소(`truncate`) 안에 두면 잘리므로 그
 * 바깥에 형제로 둔다.
 *
 * toggle-ui-kit `Badge` 는 6px 점을 16px 상자에 가운데 정렬해 담기 때문에, 이렇게
 * 모서리에 정확히 물리는 배치에는 상자 크기가 걸림돌이 된다.
 */
export const NewDot = ({ className }: { className?: string }) => (
  <span
    aria-hidden
    className={cn(
      "absolute left-full top-[-2px] size-2 shrink-0 rounded-full bg-red-500",
      "ring-2 ring-red-500/24",
      className,
    )}
  />
);
